import { Button, Slider, Stack } from '@mui/material';
import { useMemo } from 'react';
import Iconify from 'src/components/iconify';
import { useLivekitRTCState } from 'src/provider/VoiceChannel/livekit/useLivekitRTCState';

const MIN = 0;
const MAX = 100;

const marks = [
  {
    value: MIN,
    label: '',
  },
  {
    value: MAX,
    label: '',
  },
];

export const VoiceParticipantVolumeControl = ({
  meetId,
  minWidth = 150,
}: { meetId: string | undefined; minWidth?: number }) => {
  const { remoteParticipants, updateRemoteParticipant } = useLivekitRTCState();

  const muted = useMemo(
    () => (meetId ? remoteParticipants[meetId]?.localMuted : false),
    [remoteParticipants, meetId],
  );

  const volume = useMemo(() => {
    if (!meetId || !remoteParticipants[meetId]) return 100;
    return remoteParticipants[meetId].volume * 100;
  }, [remoteParticipants, meetId]);

  const handleChangeVolume = (event: Event, value: number | number[]) => {
    if (!meetId) return;
    if (value === volume) return;
    updateRemoteParticipant(meetId, { volume: (value as number) / 100 });
  };

  const handleMute = () => {
    if (!meetId) return;
    updateRemoteParticipant(meetId, { localMuted: !muted });
  };

  return (
    <Stack direction="row" alignItems="center" gap={1} minWidth={minWidth}>
      <Button variant="text" sx={{ minWidth: 0 }} onClick={handleMute}>
        <Iconify
          icon={muted ? 'tabler:headphones-off' : 'tabler:headphones'}
          width={24}
          height={24}
        />
      </Button>
      <Slider
        onChange={handleChangeVolume}
        aria-label="Volume"
        value={volume}
        size="small"
        step={10}
        marks={marks}
        min={MIN}
        max={MAX}
        valueLabelDisplay="auto"
        disabled={muted}
        sx={{ marginX: 1 }}
      />
    </Stack>
  );
};
